import { Component, Input } from '@angular/core';

const DEFAULT_ICON_SIZE = 20;

@Component({
  selector: 'app-plus-icon',
  standalone: true,
  templateUrl: './plus-icon.component.html'
})
export class PlusIconComponent {
  @Input() size?: number = DEFAULT_ICON_SIZE;
  @Input() width?: number;
  @Input() height?: number;
}
